function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_765_46949)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36 17C36 25.2843 29.2843 38 21 38C12.7157 38 6 25.2843 6 17C6 8.71573 12.7157 2 21 2C29.2843 2 36 8.71573 36 17Z",
  fill: "#FF9AD5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 39C25.6617 39 29.6736 35.4545 32.4473 31.1481C35.2458 26.8032 37 21.368 37 17C37 8.16344 29.8366 1 21 1C12.1634 1 5 8.16344 5 17C5 21.368 6.7542 26.8032 9.55269 31.1481C12.3264 35.4545 16.3383 39 21 39Z",
  stroke: "white",
  strokeWidth: 2
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.55 26.09L13.96 27.5L15.75 25.7001L14.34 24.29L12.55 26.09ZM20 27H22V30H20V27ZM10 18H13V20H10V18ZM22 11.05V15.01L23 15.59C24.24 16.31 25 17.63 25 19.05C25 21.26 23.21 23.05 21 23.05C18.79 23.05 17 21.26 17 19.05C17 17.63 17.77 16.31 19 15.59L20 15.01V11.05H22ZM24 9.05005H18V13.86C16.21 14.9 15 16.83 15 19.05C15 22.36 17.69 25.05 21 25.05C24.31 25.05 27 22.36 27 19.05C27 16.83 25.79 14.9 24 13.86V9.05005ZM29 18H32V20H29V18ZM26.24 25.71L28.03 27.51L29.44 26.1L27.64 24.31L26.24 25.71Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_765_46949",
  x: 0,
  y: 0,
  width: 42,
  height: 48,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.603922 0 0 0 0 0.835294 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_765_46949"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_765_46949",
  result: "shape"
})));

function SvgIlluminato(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluminato);
export default __webpack_public_path__ + "static/media/illuminato.006fbd27.svg";
export { ForwardRef as ReactComponent };